import React from "react";

const Header = () => {
  return (
    <div className="ui fixed menu" style={{ backgroundColor : "rgb(2,0,36)",}}>
      <div className="ui container center">
        <h2 style={{color:"white"}}>Contact Manager</h2>
      </div>
    </div>
  );
};

export default Header;
